import { Inject, Injectable } from '@angular/core';
import { TInputAppEnvironmentVars } from '@monorepo/types';

const MeasurementQcEndPoints = {
  GET_MQC_BCTX_DETAILS_BY_TAG_ID: 'GET_MQC_BCTX_DETAILS_BY_TAG_ID',
  UPDATE_MQC_THRESHOLD_OF_BCTX: 'UPDATE_MQC_THRESHOLD_OF_BCTX',
  SAVE_PER_PIECE_TAG_MEASUREMENTS: 'SAVE_PER_PIECE_TAG_MEASUREMENTS',
  FETCH_MEASUREMENT_QC_TRANSACTION_LOG: 'FETCH_MEASUREMENT_QC_TRANSACTION_LOG',
  UNDO_PER_PIECE_MEASUREMENT: 'UNDO_PER_PIECE_MEASUREMENT',
  GET_MEASUREMENTS_LIST_BASED_ON_SIZE: 'GET_MEASUREMENTS_LIST_BASED_ON_SIZE',
};

type TMeasurementQcEndPoints = typeof MeasurementQcEndPoints;
type TMeasurementQcEndPointsTypes = keyof TMeasurementQcEndPoints;
type TEnvVariables = TMeasurementQcEndPoints;

@Injectable({
  providedIn: 'root',
})
export class MeasurementQcEnvProvider {
  private protocol = 'http';
  private service_host = '';

  private env_vars: TEnvVariables = {
    GET_MQC_BCTX_DETAILS_BY_TAG_ID: '',
    UPDATE_MQC_THRESHOLD_OF_BCTX: '',
    SAVE_PER_PIECE_TAG_MEASUREMENTS: '',
    FETCH_MEASUREMENT_QC_TRANSACTION_LOG: '',
    UNDO_PER_PIECE_MEASUREMENT: '',
    GET_MEASUREMENTS_LIST_BASED_ON_SIZE: '',
  };

  constructor(@Inject('environment') ENV: TInputAppEnvironmentVars) {
    if (ENV.protocol !== null) {
      this.protocol = ENV.protocol;
    }
    if (ENV.service_host !== null) {
      this.service_host = ENV.service_host;
    }
    this.registerVars(ENV);
  }

  registerVars(environment: TInputAppEnvironmentVars) {
    const HOST_DOMAIN_WITH_PROTOCOL = this.protocol + this.service_host;

    this.env_vars.GET_MQC_BCTX_DETAILS_BY_TAG_ID =
      HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/measurement/qc/fetchBctxDetails';
    this.env_vars.UPDATE_MQC_THRESHOLD_OF_BCTX =
      HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/measurement/qc/addOrUpdateThreshold';
    this.env_vars.SAVE_PER_PIECE_TAG_MEASUREMENTS =
      HOST_DOMAIN_WITH_PROTOCOL +
      environment.bulk_count_app_services +
      '/api/v1/measurement/qc/savePerPieceTagMeasurementQC';
    this.env_vars.FETCH_MEASUREMENT_QC_TRANSACTION_LOG =
      HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/measurement/qc/transactionLog';
    this.env_vars.UNDO_PER_PIECE_MEASUREMENT =
      HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/measurement/qc/transaction/undo';
    this.env_vars.GET_MEASUREMENTS_LIST_BASED_ON_SIZE =
      HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/api/v3/getpoms/listing/byFactoryId';
  }

  getEnvVar(key: TMeasurementQcEndPointsTypes): string {
    return this.env_vars[key];
  }
}
